import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  REOPEN_CONVERSATION_POST,
  REOPEN_CONVERSATION_GET,
} from "./actionTypes";
import { reopenConversationRes } from "./actions";
import axios from "axios";

function* reopenConversationGet({ payload: { id } }) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/conversation/reopen?id=${id}`
    );
    const data = response?.data?.data;
    if ((response.status >= 200 || response.status <= 299) && data) {
      const object = { [data?.conversationId]: data };
      yield put(
        reopenConversationRes(
          { data: object, loading: false, success: "reopenGet" },
          "reopenGet"
        )
      );
    } else throw response.data;
  } catch (error) {
    yield put(
      reopenConversationRes({
        error: "reopenGet",
        loading: false,
        success: false,
      })
    );
  }
}

function* reopenConversationPost({ payload: { data: body, id } }) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/conversation/reopen?id=${id}`,
      body
    );
    const data = response?.data?.data;
    if ((response.status >= 200 || response.status <= 299) && data) {
      const object = { [data?.conversationId]: data };
      yield put(
        reopenConversationRes(
          { data: object, loading: false, success: "reopenPost" },
          "reopenPost"
        )
      );
    } else throw response.data;
  } catch (error) {
    yield put(
      reopenConversationRes({
        error: "reopenPost",
        loading: false,
        success: false,
      })
    );
  }
}

export function* watchReopenConversationGet() {
  yield takeEvery(REOPEN_CONVERSATION_GET, reopenConversationGet);
}
export function* watchReopenConversationPost() {
  yield takeEvery(REOPEN_CONVERSATION_POST, reopenConversationPost);
}

function* dataSaga() {
  yield all([
    fork(watchReopenConversationGet),
    fork(watchReopenConversationPost),
  ]);
}

export default dataSaga;
